<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-电子运单-修改
    -->
    <el-dialog
    title="修改电子运单"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form 
        ref="formRef" 
        :model="form" 
        :rules="rules" 
        label-width="120px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- <el-form-item label="检查项" prop="electronic_waybill_item_id">
              <el-select 
                v-model="form.electronic_waybill_item_id" 
                placeholder="请选择检查项"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="dept in itemList"
                  :key="dept.electronic_waybill_item_id"
                  :label="dept.name"
                  :value="dept.electronic_waybill_item_id"
                />
              </el-select>
            </el-form-item> -->
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="管理方式" prop="type" required>
              <el-radio-group v-model="form.type">
                <el-radio :label="1">线上</el-radio>
                <el-radio :label="0">线下</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="驾驶时间" prop="ew_time" required>
              <div class="block">
                <el-date-picker
                  size="small"
                  v-model="form.ew_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文件上传" prop="certificate_w" required>
              <el-button icon="el-icon-picture-outline" @click="openFileUpload">选择文件</el-button>
         
              <div style="color: #67C23A; font-size: 12px; margin-top: 5px;">
                {{ form.certificate_w }}
              </div>
              <div v-if="uploadStatus === 'error'" style="color: #F56C6C; font-size: 12px; margin-top: 5px;">
                文件上传失败，请重新上传
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="其它凭证" prop="certificate_img">
          <div class="draggable-list">
            <draggable :list="normalizedCertificateImg" class="wrapper" :options="{ animation: 150 }">
              <transition-group>
                <div v-for="(item, index) in form.certificate_img" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="凭证图片"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload()">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item> -->
        
        <el-form-item prop="info" label="出车记录">
          <el-input 
            v-model="form.info" 
            type="textarea"
            :rows="9"
            placeholder="请输入出车记录内容"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
        
        <el-form-item prop="trajectory" label="跑的路线">
          <el-input 
            v-model="form.trajectory" 
            type="textarea"
            :rows="9"
            placeholder="请输入跑的路线内容"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
        
        <div class="common-button-wrapper" style="text-align: center; margin-top: 30px;">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
      <Upload v-if="isuploadFile" :isupload="isuploadFile" @returnImgs="returnFilesFunc">上传文件</Upload>
  </div>
</el-dialog>
  
</template>
<script>
// import Electronic_waybillApi from '@/api/electronic_waybill.js';
import AfuncApi from '@/api/afunc.js'
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
      isuploadFile:false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
       electronic_waybill_item_id: '', 
        type: '', 
        info: '',
        trajectory: '',
        ew_time: '',
        certificate_img: [],
        certificate_w: ''
      },
      rules: {
        // electronic_waybill_item_id: [
        //   { 
        //     required: true, 
        //     message: '请选择检查项', 
        //     trigger: ['change', 'blur']  // 添加 blur 触发
        //   }
        // ],
        type: [
          { 
            required: true, 
            message: '请选择管理方式', 
            trigger: ['change', 'blur'] 
          }
        ],
        ew_time: [
          { 
            required: true, 
            message: '请选择记录时间', 
            trigger: ['change', 'blur'] 
          }
        ],
        certificate_w: [
          { 
            required: true, 
            message: '请上传文件', 
            trigger: ['change', 'blur'] 
          }
        ]
      },
      loading: false,
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      itemList:[],
      uploadStatus: '',
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.loadElectronicWaybill();
    this.getDetail();
  },
  props: ["open_add","electronic_waybill_id"],
  computed: {
    // 确保 certificate_img 始终是数组
    normalizedCertificateImg() {
      if (!this.form.certificate_img) return [];
      
      if (Array.isArray(this.form.certificate_img)) {
        return this.form.certificate_img;
      }
      
      if (typeof this.form.certificate_img === 'string') {
        try {
          return this.form.certificate_img ? JSON.parse(this.form.certificate_img) : [];
        } catch (e) {
          return this.form.certificate_img ? [{ file_path: this.form.certificate_img }] : [];
        }
      }
      
      return [];
    }
  },
  methods: {
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        console.log('收到的图片数据:', e);
        console.log('数据类型:', typeof e);
        
        // 确保 e 是数组
        let images = e;
        if (typeof e === 'string') {
          try {
            images = JSON.parse(e);
          } catch (error) {
            console.error('解析图片数据失败:', error);
            images = [];
          }
        }
        
        this.form.certificate_img = this.form.certificate_img.concat(images);
      }
      this.isupload = false;
    },
    returnFilesFunc(e) {
      this.uploadStatus = ''
      if (e != null && e.length > 0) {
        this.form.certificate_w = e[0].file_path;
        this.uploadStatus = 'success'
        this.isFileUploaded = true;
        this.$nextTick(() => {
          this.$refs.formRef.validateField('certificate_w')
        })
      }
      this.isuploadFile = false;
    },
    async loadElectronicWaybill() {
      try {
        const response = await AfuncApi.call({
          model: 'electronic_waybill_item',
          action: 'index',
          page: 1,
          list_rows: 1000
        })
        
        if (response.code === 1 && response.data.list) {
          this.itemList = response.data.list.data || []
        }
      } catch (error) {
        console.error('加载检查项列表失败:', error)
        this.$message.error('加载检查项列表失败')
      }
    },
    // 打开图片上传组件
    openUpload() {
      this.isupload = true;
    },
    openFileUpload() {
      this.isuploadFile = true;
    },
    // 删除图片
    deleteImg(index,) {
      this.form.certificate_img.splice(index, 1)
    },
    // 关闭弹窗
    dialogFormVisible() {
      this.$emit("close", { openDialog: false })
    },
    async getDetail() {
      try {
        const response = await AfuncApi.call({
          model: 'electronic_waybill',
          action: 'detail',
          electronic_waybill_id: this.electronic_waybill_id
        })
        
        if (response.code === 1 && response.data) {
          const data = response.data;
          
          // 处理 certificate_img
          let certificateImg = data.certificate_img;
          
          // 如果是字符串，尝试安全解析
          if (typeof certificateImg === 'string' && certificateImg.trim()) {
            const parsed = this.safeJsonParse(certificateImg);
            
            if (Array.isArray(parsed)) {
              certificateImg = parsed;
            } else if (parsed && typeof parsed === 'object') {
              certificateImg = [parsed];
            } else if (parsed && typeof parsed === 'string') {
              certificateImg = [{ file_path: parsed }];
            } else {
              certificateImg = [];
            }
          }
          // 如果是对象但不是数组，包装成数组
          else if (certificateImg && typeof certificateImg === 'object' && !Array.isArray(certificateImg)) {
            certificateImg = [certificateImg];
          }
          // 如果不是数组，设为空数组
          else if (!Array.isArray(certificateImg)) {
            certificateImg = [];
          }
          
          // type: 1-线上 0-线下，0 为有效值不能用 || 判断
          const typeVal = (data.type === 0 || data.type === 1) ? data.type : '';
          this.form = {
            electronic_waybill_item_id: data.electronic_waybill_item_id || '',
            type: typeVal,
            info: data.info || '',
            trajectory: data.trajectory || '',
            ew_time: data.ew_time || '',
            certificate_img: certificateImg,
            certificate_w: data.certificate_w || ''
          };
        }
      } catch (error) {
        console.error('加载失败:', error);
        this.$message.error('加载失败');
      }
    },
    async onSubmit() {
      try {
        // Vue2表单校验
        await this.$refs.formRef.validate()
      } catch (error) {
        return // 校验失败则返回
      }
      
      try {
        this.loading = true
        this.form.electronic_waybill_id = this.electronic_waybill_id;
        // 处理表单数据
        const formData = {
          ...this.form
        }

        // 调用新增接口
        const response = await AfuncApi.call({
          model: 'electronic_waybill',
          action: 'edit',
          ...formData
        })
        
        if (response.code === 1) {
          this.$message.success(response.msg || '成功')
          this.dialogFormVisible()
        } else {
          this.$message.error(response.msg || '失败')
        }
      } catch (error) {
        console.error('失败:', error)
        this.$message.error('失败')
      } finally {
        this.loading = false
      }
    },
    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/electronic_waybill/index/part/edit.vue